<app-breadcrumbs></app-breadcrumbs>
<div class="section section-padding">
  <div class="container">
    <div class="row">
      <div class="col-lg-8">
        <h4>Your Cart:</h4>
        <div class="cart-container" *ngIf="cartItems.length > 0; else emptyCart">
          <ul class="list-group">
            <li class="list-group-item" *ngFor="let item of cartItems">
              <div class="row cart-item">
                <div *ngIf="!isDrug" class="col-lg-5">
                  <div>{{ cartItemName[item.id] }}</div>
                </div>
                <div *ngIf="isDrug" class="col-lg-6">
                  <div class="row">
                    <div class="col-lg-4">
                      <div class="mt-3">{{ cartItemName[item.id] }}</div>
                    </div>
                    <div class="col-lg-8">
                      <select 
                        class="form-control"
                        [ngModel]="selectedQuantities[item.id]"
                        (ngModelChange)="onQuantityTypeChange($any(item), $event)"
                        >
                        <option *ngFor="let qty of $any(item).quantity_types" [ngValue]="qty">
                          {{ qty.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-lg-2">
                  <div class="quantity-controls">
                    <i class="fal fa-minus" (click)="decreaseQuantity(item)"></i>
                     <span>{{ itemQuantities[item.id]}}</span>
                    <i class="fal fa-plus" (click)="increaseQuantity(item)"></i>
                  </div>
                </div>
                <div *ngIf="!isDrug" class="col-lg-3">
                   <div>{{ (+$any(item).price * itemQuantities[item.id]) + ' UGX' }}</div>
                </div>
                <div *ngIf="isDrug" class="col-lg-2">
                  <div>{{ (+itemAmounts[item.id] * itemQuantities[item.id]) + ' UGX' }}</div>
                </div>
                <div class="col-lg-2">
                  <button class="btn btn-danger btn-sm" (click)="removeFromCart(item)">Remove</button>
                </div>
              </div>
            </li>   
          </ul>
        </div>
         <div class="medical-consultation-section" *ngIf="addConsultation">
          <div class="list-group-item">
            <div class="row">
              <div class="col-lg-6">
                <div>Medical Consultation</div>
              </div>
              <div class="col-lg-4">
                <div>{{ consultationAmount + ' UGX' }}</div>
              </div>
              <div class="col-lg-2 button">
                <button class="btn btn-danger btn-sm" (click)="removeConsultationFromCart()">Remove</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="sidebar style-10 mt-5 mt-lg-0">
          <div class="widget widget-booking">
            <h5 class="widget-title">Cart Summary</h5>
            <ul>
              <li class="d-flex align-items-center justify-content-between">
                <span>Total Cost</span>
                <span><b> {{ totalCartCost + ' UGX'}}</b></span>
              </li>
            </ul>
            <hr>
            <ul>
              <li class="d-flex align-items-center justify-content-between">
                <a (click)="checkout()" class="sigma_btn btn-block btn-sm mt-4">
                  Continue
                  <i class="fal fa-arrow-right ml-3"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-lg-12">
        <div class="recommended-tests mt-4" *ngIf="recommendedMedicalTests.length > 0">
          <h5>Recommended Medical Tests:</h5>
          <div class="container medical-tests-section">
            <div class="profile-item">
              <div class="row ngx-slick-carousel-container">
                <ngx-slick-carousel
                class="profile-slider"
                [config]="slickCarouselConfig"
                >
                  <div ngxSlickItem *ngFor="let medicalTest of recommendedMedicalTests">
                    <img (click)="goToMedicalTestDetails(medicalTest)" [src]="medicalTest?.images?.[0]" alt="{{ medicalTest.name }}">
                    <div class="profile-inner">
                      <div class="duration-price-container">
                        <span>Duration: <b>{{ medicalTest.duration }}</b></span>
                        <span>{{ medicalTest.price }} UGX</span>
                      </div>
                      <a class="primary-color">
                        <h5 class="test-title">{{ medicalTest.name }}</h5>
                      </a>
                      <p class="pb-0">{{ medicalTest.description | removeHtml }}</p>
                      <a (click)="addToCart(medicalTest)" class="sigma_btn btn-link primary-color">Add to cart<i class="icofont-swoosh-right"></i></a>
                    </div>
                  </div>
                </ngx-slick-carousel>
              </div>
            </div>
          </div>
        </div>
        <div class="recommended-tests mt-4" *ngIf="recommendedDrugs.length > 0">
          <h5>Recommended Drugs:</h5>
          <div class="container medical-tests-section">
            <div class="profile-item">
              <div class="row ngx-slick-carousel-container">
                <ngx-slick-carousel
                class="profile-slider"
                [config]="slickCarouselConfig"
                >
                  <div ngxSlickItem *ngFor="let drug of recommendedDrugs">
                    <img (click)="goToDrugDetails(drug)" [src]="drug?.images?.[0]" alt="{{ drug.name }}">
                    <div class="profile-inner">
                      <div class="duration-price-container">
                        <span class="availability" [ngClass]="{'out-of-stock': selectedQuantities[drug.id]?.is_in_stock === 0 }">
                          {{ selectedQuantities[drug.id]?.is_in_stock === 1 ? 
                            'In Stock' : 'Out of Stock' }}
                        </span>
                        <span>
                          {{ selectedQuantities[drug.id]?.selling_price ? 
                            ('UGX ' + selectedQuantities[drug.id]?.selling_price) : 'Select quantity type' }}
                        </span>
                      </div> 
                      <div class="duration-price-container">
                        <a (click)="goToDrugDetails(drug)" class="primary-color">
                          <h5 class="test-title">{{ drug.name }}</h5>
                        </a>
                        <span class="price">{{ '(' + drug.country_of_origin + ')' }}</span>
                      </div> 
                      <p class="pb-0">{{ drug.description | removeHtml }}</p>
                      <div class="add-cart-buttons">
                        <button 
                          class="sigma_btn btn-block btn-sm mb-3" 
                          (click)="addToCart(drug, selectedQuantities[drug.id])"
                          [disabled]="selectedQuantities[drug.id]?.is_in_stock === 0"
                          [title]="selectedQuantities[drug.id]?.is_in_stock === 0 ? 'Out of stock' : ''"
                          [ngClass]="{ 'btn-remove': ({cartItems} | buttonText: drug) === 'Remove' }"
                        >
                          {{ {cartItems } | buttonText: drug }}
                        </button>
                      </div>
                    </div>
                  </div>
                </ngx-slick-carousel>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ng-template #emptyCart>
        <p *ngIf="cartItems.length === 0 && !addConsultation">Your cart is empty.</p>
      </ng-template>
    </div>
  </div>
</div>
